import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    showTimeRange: String,
    performanceId: Number,
    canClick: Boolean,
    performanceDuration: String
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_y6007283_mv',
      cid: 'c_c21utqjf',
      abtest: 1,
      custom: {
        performance_id: this.performanceId
      }
    });
  },
  methods: {
    buttonClick: function buttonClick() {
      if (!this.canClick) return;
      this.$emit('buttonClick');
      window.lxTagReport('c_c21utqjf', 'b_movie_y6007283_mc', {
        performance_id: this.performanceId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_y6007283_mc',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.performanceId
        }
      });
    }
  }
};